import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ArrowIcon from "../icons/arrowIcon";
import { premiumMenuItems } from "./constants";

import {
  Container,
  Description,
  Header,
  ItemContainer,
  PremiumNote,
  Price,
  PriceOption,
  PricesWrapper,
  SectionTitleWrapper,
  Subtitle,
  TextWrapper,
  Title,
} from "./styles";

export const PremiumMenu = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Header>
        <span
          onClick={() => navigate("/food")}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <ArrowIcon />
          <p>{t("Premium selekcija  Štrafta")}</p>
        </span>
      </Header>

      <Container>

        {premiumMenuItems.map((item, index) => (
          <Fragment
            key={`${item.section ?? item.title}-${index}`}
          >
            {item.section && (
              <SectionTitleWrapper>
                <p>{t(item.section)}</p>
              </SectionTitleWrapper>
            )}

            {item.title && (
              <ItemContainer isFirst={item.isFirst}>
                <TextWrapper
                  isDescription={Boolean(item.description)}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      flexWrap: "wrap",
                      gap: "4px",
                    }}
                  >
                    <Title>{t(item.title)}</Title>

                    {item.subtitle && (
                      <Subtitle>{item.subtitle}</Subtitle>
                    )}
                  </span>

                  {item.description && (
                    <Description>
                      ({t(item.description)})
                    </Description>
                  )}
                </TextWrapper>

                {item.price && (
                  <Price>{item.price}</Price>
                )}

                {item.prices && (
                  <PricesWrapper>
                    {item.prices.map((option) => (
                      <PriceOption
                        key={`${item.title}-${option.size}`}
                      >
                        <span>{option.size}/</span>
                        <Price>{option.price}</Price>
                      </PriceOption>
                    ))}
                  </PricesWrapper>
                )}
              </ItemContainer>
            )}
          </Fragment>
        ))}

        <PremiumNote>
          {t("Pažljivo odabrani specijaliteti koje sa ponosom preporučujemo")}
        </PremiumNote>
      </Container>
    </>
  );
};